import type { AccommodationSearchResponse } from '~/types/AccommodationSearch'
import type { CampsiteResponse } from '~/types/Campsite'

export const useGaSearchAccommodationEvent = (
  searchData: AccommodationSearchResponse,
  siteData: CampsiteResponse
) => {
  if (process.client) {
    const searchStore = useSearchv2Store()
    const accommodationStore = useAccommodationStore()

    const event = ref('search_updated')
    if (accommodationStore.initialLoad) {
      event.value = 'search_new'
      accommodationStore.initialLoad = false
    }

    const source = 'MANUAL'
    const occupied = searchData.data.occupied
      ? searchData.data.occupied.length
      : 0
    const suggested = searchData.data.alternatives
      ? searchData.data.alternatives.length
      : 0
    const exact = searchData.data.accommodations
      ? searchData.data.accommodations.length
      : 0

    const accommodations = [] as Array<object>
    searchData.data.accommodations?.map((accommodation) => {
      accommodations.push({
        aircon: accommodation.aircondition,
        beds: accommodation.bedrooms,
        discount:
          (accommodation.priceBeforeFeesBeforeDiscount as number) -
          accommodation.priceBeforeFeesAfterDiscount,
        id: accommodation.id,
        labels: accommodation.aircondition,
        name: accommodation.name,
        price: accommodation.priceBeforeFeesAfterDiscount,
      })
    })

    useGaSharedFunction.gtagEvent(event.value, {
      search: {
        match_type: 'EXACT',
        sort: `${searchStore.searchParameters.meta.value.orderBy} ${searchStore.searchParameters.meta.value.order}`,
        location: {
          country: siteData.data.meta.country.globalName,
          parc: siteData.data.name,
          region: siteData.data.meta.area.globalName,
        },
        party: {
          adults: searchStore.getNumberOfAdults,
          children: searchStore.getNumberOfChildren,
        },
        results: {
          exact: exact + occupied,
          source: source,
          suggested: suggested,
          total: exact + suggested + occupied,
          price: {
            from: searchData.data.meta.minPrice
              ? searchData.data.meta.minPrice.sellPrice
              : 0,
            to: 0, //we dont get this value from backend
          },
        },
        season: {
          current: {
            year: searchStore.getStartDate
              ? new Date(searchStore.getStartDate).getFullYear()
              : null,
          },
        },
        time: {
          user_defined: true,
          week_number: searchStore.getStartDate
            ? useGaSharedFunction.getWeekNumberFromDate(
                searchStore.getStartDate
              )
            : null,
          date: {
            end: searchStore.getEndDate,
            start: searchStore.getStartDate,
          },
          days: {
            long: searchStore.searchParameters.parameters.value.duration,
            until: searchStore.getStartDate
              ? useGaSharedFunction.getDaysTill(searchStore.getStartDate)
              : null,
          },
        },
      },
      parc: [
        {
          name: siteData.data.name,
          id: siteData.data.meta.site?.id,
          ownership: siteData.data.ownership ? 'OWNED' : 'PARTNER',
          location: {
            country: siteData.data.meta.country.globalName,
            region: siteData.data.meta.area.globalName,
          },
          price: {
            from: searchData.data.meta.minPrice
              ? searchData.data.meta.minPrice.sellPrice
              : 0,
            to: 0, //we dont get this value from backend
          },
          featured: 'Search Results',
          accommodation: accommodations,
        },
      ],
    })
  }
}
